// routerSurescriptsRecordLocator.ts
import { createRouter, createWebHashHistory } from 'vue-router';
import SurescriptsDocumentSearch from './SurescriptsDocumentSearch.vue'
import DocumentList from './DocumentList.vue'

const routes = [
    { name:"Search", path: '/', component: SurescriptsDocumentSearch },
    { name:"Documents", path: '/documents', component: DocumentList }
    //{ name:"Import", path: '/document/import', component: DocumentImport },
 ];

 export function getRouter()
 {
     return createRouter({
         // Provide the history implementation to use
         //  IMPORTANT -- Do not expose the route using a variable instead of a function call when using hash history. 
         //                  It will break OFficeMd when it looks at QueryString data.  Adding #/ which breaks pages
         history: createWebHashHistory(),
         routes:  routes
         });
 }
 